import { useEffect, useState } from "react";
import { ToggleButton, Button2, QuickActionSelect } from "../Components";
import BankingPortal from "../Components/add-funds/BankingPortal";
import MainLayout from "../layout/MainLayout";
import plusIcon from "../assets/icons/plus.png";
import DirectDebit from "../Components/add-funds/DirectDebit";
import CreditDebitCard from "../Components/add-funds/CreditDebitCard";

import { useAccounts, computeTotalBalance } from "../data/live";

const AddFunds = ({ initialTab = "Bank Deposit" }) => {
  const { accounts, refresh } = useAccounts();
  const { total } = computeTotalBalance(accounts, "AUD");
  const [tab, setTab] = useState(initialTab);

  const [targetAccountId, setTargetAccountId] = useState("");
  useEffect(() => {
    if (accounts.length > 0 && !targetAccountId) {
      const def = accounts.find((a) => a.isDefault) || accounts[0];
      setTargetAccountId(def.id);
    }
  }, [accounts, targetAccountId]);

  const targetAccount = accounts.find((a) => a.id === targetAccountId);

  const renderTab = () => {
    const props = {
      accounts,
      targetAccountId,
      setTargetAccountId,
      targetAccount,
      onSuccess: refresh,
    };
    switch (tab) {
      case "Bank Deposit":
        return <BankingPortal {...props} />;
      case "Direct Debit":
        return <DirectDebit {...props} />;
      case "Credit/Debit Card":
        return <CreditDebitCard {...props} />;
      default:
        return <BankingPortal {...props} />;
    }
  };

  return (
    <MainLayout
      expand={false}
      NavName="Add Funds"
      pageClassName="dashboard-page finance-action-page add-funds-page"
      contentClassName="dashboard-content"
    >
      <div className="finance-action-shell">
          <div className="finance-action-overview">
            <div>
              <span className="dashboard-eyebrow">Wallet funding</span>
              <h2>Add Funds</h2>
              <p>Top up your selected wallet using bank deposit, direct debit, or card funding.</p>
            </div>
            <div className="d-flex gap-3 align-items-center flex-wrap justify-content-md-end">
              <p className="p-0 m-0 fs14px">
                Available balance:{" "}
                <span className="fs-6 fw-medium" style={{ color: "#1bbb6b" }}>
                  {total.toLocaleString()} AUD
                </span>
              </p>
              <Button2
                buttonName={"Refresh"}
                className={"btn-outline-success"}
                divClassName={"gap-1"}
                icon={<img src={plusIcon} alt="add" />}
                onClick={refresh}
              />
              <QuickActionSelect className="change-down-icon-white" />
            </div>
          </div>

          <div className="finance-action-toolbar d-flex justify-content-md-between justify-content-center flex-wrap gap-2 mt-4">
            <ToggleButton
              options={["Bank Deposit", "Direct Debit", "Credit/Debit Card"]}
              defaultValue={tab}
              onChange={(v) => setTab(v)}
            />
          </div>
          <div className="finance-action-card row mt-4 justify-content-between p-3">
            {renderTab()}
          </div>
      </div>
    </MainLayout>
  );
};

export default AddFunds;
